<template>
  <main id="colliScrollBox" class="flex flex-col items-center">
    <main-content-container>
      <h2 class="font-semibold  mb-6 mt-3 font-roboto text-xlg text-black">
        {{ $t("product_carrier") }}
      </h2>
      <product-carrier />
    </main-content-container>
  </main>
</template>

<script>
import { computed, defineComponent, reactive, watch } from "vue";
import { useStore } from "vuex";

import MainContentContainer from "../../components/global/MainContentContainer.vue";
import {
  AUTH_TYPES,
  CUSTOMER_COLLIS_TYPES,
  CUSTOMER_POSITIONS_TYPES,
  STORE_TYPES,
} from "../../store/types";
import ProductCarrier from "./show/ProductCarrier.vue";

export default defineComponent({
  components: {
    MainContentContainer,
    ProductCarrier,
  },
  setup() {
    const store = useStore();

    /** State */
    const state = reactive({});

    /** COMPUTEDS  */
    const GET_USER = computed(
      () => store.getters[`${STORE_TYPES.AUTH}/${AUTH_TYPES.GET_USER}`]
    );

    function FETCH_CUSTOMER_COLLIS() {
      const dataColli = {
        id: GET_USER.value.customer_id,
      };
      store.dispatch(
        `${STORE_TYPES.CUSTOMER_COLLIS}/${CUSTOMER_COLLIS_TYPES.FETCH_CUSTOMER_COLLIS}`,
        dataColli
      );
    }
    function FETCH_POSITIONS() {
      store.dispatch(
        `${STORE_TYPES.CUSTOMER_POSITIONS}/${CUSTOMER_POSITIONS_TYPES.FETCH_CUSTOMER_POSITIONS}`,
        GET_USER.value.customer_id
      );
    }

    watch(
      () => GET_USER.value,
      (newValue) => {
        if (newValue != null && newValue.customer_id != null) {
          FETCH_CUSTOMER_COLLIS(newValue.customer_id);
          FETCH_POSITIONS(newValue.customer_id);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      state,
    };
  },
});
</script>
